var parseType, projectRegex, syncTypeAttributeToItemBody, tagsHelper, taskRegex;

tagsHelper = require('./tags');

taskRegex = /^([\-+*])\s/;

projectRegex = /:$/;

parseType = function(contentString) {
  if (contentString.match(taskRegex)) {
    return 'task';
  } else if (contentString.match(projectRegex)) {
    return 'project';
  } else {
    return 'note';
  }
};

syncTypeAttributeToItemBody = function(item, newType, oldType) {
  var ref, ref1, ref2, ref3, trailingTagsLength;
  switch (oldType) {
    case 'project':
      trailingTagsLength = (ref = (ref1 = tagsHelper.parseTags(item.bodyString).trailingMatch) != null ? ref1[0].length : void 0) != null ? ref : 0;
      item.replaceBodyRange(item.bodyString.length - (1 + trailingTagsLength), 1, '');
      break;
    case 'task':
      item.replaceBodyRange(0, 2, '');
  }
  switch (newType) {
    case 'project':
      trailingTagsLength = (ref2 = (ref3 = tagsHelper.parseTags(item.bodyString).trailingMatch) != null ? ref3[0].length : void 0) != null ? ref2 : 0;
      return item.replaceBodyRange(item.bodyString.length - trailingTagsLength, 0, ':');
    case 'task':
      return item.replaceBodyRange(0, 0, '- ');
  }
};

module.exports = {
  taskRegex: taskRegex,
  projectRegex: projectRegex,
  parseType: parseType,
  syncTypeAttributeToItemBody: syncTypeAttributeToItemBody
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/serializations/taskpaper/types.js
 ** module id = 200
 ** module chunks = 0
 **/